// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageWithContentCard_wrapper__DPfrX"};